var map = {
	"./LANGEBIO.jpg": "872f",
	"./ahorcado0.jpg": "9975",
	"./ahorcado1.jpg": "d57a",
	"./ahorcado2.jpg": "d8dc",
	"./ahorcado3.jpg": "5277",
	"./ahorcado4.jpg": "025b",
	"./ahorcado5.jpg": "e6bf",
	"./ahorcadoNuevo.png": "796e",
	"./ahorcadoNuevo0.png": "76bb",
	"./ahorcadoNuevo1.png": "2268",
	"./ahorcadoNuevo2.png": "9156",
	"./ahorcadoNuevo3.png": "e15a",
	"./ahorcadoNuevo4.png": "001d",
	"./ahorcadoNuevo5.png": "d2c2",
	"./bioinformatica.jpg": "5831",
	"./blockchain.jpg": "a914",
	"./correcto.png": "b241",
	"./el-ahorcado.jpg": "69c1",
	"./genoma.jpg": "df3c",
	"./introducir.png": "414d",
	"./lista.png": "ac84",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./material2.jpg": "bf9b",
	"./pista.png": "6cee",
	"./pista2.png": "6612",
	"./revelado.png": "2f75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";